/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterGroupDto } from '../../models/center-group-dto';
import { CreateCenterGroupDto } from '../../models/create-center-group-dto';

export interface CenterGroupControllerUpdateGroup$Params {
  id: string;
      body: CreateCenterGroupDto
}

export function centerGroupControllerUpdateGroup(http: HttpClient, rootUrl: string, params: CenterGroupControllerUpdateGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterGroupDto>> {
  const rb = new RequestBuilder(rootUrl, centerGroupControllerUpdateGroup.PATH, 'patch');
  if (params) {
    rb.query('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterGroupDto>;
    })
  );
}

centerGroupControllerUpdateGroup.PATH = '/api/center-group/{id}';
